import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType, ref } from 'vue';
import { Locale } from '@/interfaces/api/general/language';
import { generalApi } from '@/lib/api/general';
import { defineMessages } from '@/lib/i18n';
import sharedMessages from '@/lib/shared-messages';
import { readAssertedCompany } from '@/store/main/getters';
import { store } from '@/store/index';
import { i18n } from '@/plugins/vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'SdsGhsLabelSimpleDialog',
  props: {
  value: {
    type: Boolean,
    required: true,
  },
  uuid: {
    type: String,
    default: '',
  },
  locale: {
    type: String as PropType<Locale>,
    default: 'ja-JP',
  },
  sdsProductId: {
    type: Number as PropType<number | null>,
    default: null,
  },
},
  emits: ["input", "success"],
  setup(__props, { emit: emits }: { emit: ({
  (e: 'input', value: boolean): void;
  (e: 'success', message: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props;

const $t = i18n.t.bind(i18n);

const m = defineMessages({
  title: 'GHSラベル作成',
  description:
    'ファイル形式を選択し「実行する」をクリックすると、ご自身のメールアドレスにファイルダウンロードURLが記載されたメールが送信されます。',
  helpCenterNote:
    'ラベルの表示項目については「ヘルプセンター」をご確認ください。',
  noteClassification:
    '※GHS以外の分類体系（CLPやOSHAなど）に基づいたSDSの場合でも、記載されている情報に基づいてラベルを作成します。',
  noteProcessingTime: '※データ出力には最大で60分程度かかる可能性があります。',
  noticeHazardNotReflectedTitle:
    '危険有害性情報・注意書きが反映されない場合があります',
  noticeContactForOlderSds:
    '2025年11月5日以前にアップロードされたSDSでは、これらの項目がラベルに含まれません。反映が必要な場合は「{url}」よりご連絡ください。',
  successPdf:
    'PDFの出力を受け付けました。ファイルのダウンロードURLを記載したメールをお送りします。',
  successWord:
    'Wordの出力を受け付けました。ファイルのダウンロードURLを記載したメールをお送りします。',
  errorPdf: 'PDFの出力依頼に失敗しました。',
  errorWord: 'Wordの出力依頼に失敗しました。',
});





const selectedFormat = ref<'pdf' | 'word'>('pdf');
const isLoading = ref(false);
const contactPageUrl = computed(() =>
  i18n.locale === 'ja-JP'
    ? process.env.VUE_APP_CONTACT_PAGE
    : process.env.VUE_APP_CONTACT_PAGE_EN
);
const olderSdsNoticeParts = computed(() => {
  const text = String($t(m.noticeContactForOlderSds));
  const placeholder = '{url}';
  const idx = text.indexOf(placeholder);
  if (idx === -1) {
    return { before: text, after: '' };
  }
  return {
    before: text.slice(0, idx),
    after: text.slice(idx + placeholder.length),
  };
});
const errorMessage = ref('');

const closeDialog = () => {
  errorMessage.value = '';
  emits('input', false);
};

const execute = async () => {
  const company = readAssertedCompany(store);
  const companyId = company?.uuid;
  const sdsId = props.uuid;
  if (!companyId || !sdsId) return;

  isLoading.value = true;
  errorMessage.value = '';
  try {
    await generalApi.downloadGhsLabel(companyId, sdsId, {
      display_options: {
        qr_code: true,
        component_information: true,
        signal_word: true,
        pictograms: true,
        hazard_statements: true,
        precautionary_statements: true,
        remarks: false,
        manufacturer_information: true,
        company_logo: false,
        language: props.locale === 'ja-JP' ? 'JP' : 'EN',
      },
      remarks_text: '',
      file_format: selectedFormat.value,
      sds_product_id: props.sdsProductId,
    });
    const successMsg =
      selectedFormat.value === 'pdf'
        ? String($t(m.successPdf))
        : String($t(m.successWord));
    emits('success', successMsg);
    closeDialog();
  } catch (e) {
    errorMessage.value =
      selectedFormat.value === 'pdf'
        ? String($t(m.errorPdf))
        : String($t(m.errorWord));
  } finally {
    isLoading.value = false;
  }
};

return { __sfc: true,$t, m, props, emits, selectedFormat, isLoading, contactPageUrl, olderSdsNoticeParts, errorMessage, closeDialog, execute, sharedMessages }
}

})